import { style } from '@angular/animations';
import { urlToBase64 } from "src/app/utils/utils.common";

// timePipe.transform(trip.scheduleTime, "HH:mm"),
export async function vehicleInspection(data, timePipe, userData) {
  return {
    info: {
      title: 'OEMS',
      author: 'Haseeb Rao',
      subject: 'Vehicle Inspection',
      keywords: 'OEMS Vehicle Inspection Report ',
    },
    pageSize: 'A4',
    pageMargins: userData.stateCode === 'OH' ? [10, 0, 10, 10] : [10, 40, 10, 10],
    // defaultStyle: {
    //   font: 'Roboto'
    //  },

    content: [

      {

        table: {
          widths: ['25%', 'auto',],
          body: [

            [
             (userData.stateCode === 'OH' ? {
                image: 'headerLogo',
                fit: [100, 100],
                border: [0, 0, 0, 0],
                margin: [0, -20, 0, 0],
              }: {
                text: '',
                fit: [100, 100],
                border: [0, 0, 0, 0],
                margin: [0, -20, 0, 0],
              }),

              {
                text: userData.stateCode === 'OH' ? 'OHIO DEPARTMENT OF PUBLIC SAFETY\nDIVISION OF EMERGENCY MEDICAL SERVICE' : '',
                border: [0, 0, 0, 0],
                margin: [0, 10, 0, 0],
                fontSize: '12',
                alignment: 'center',
              },
            ],

            [
              {
                text: '',
                border: [0, 0, 0, 0],
                margin: [0, 20, 0, 0],
                fontSize: '12',
                alignment: 'center',


              },
              {
                text: 'PERIODIC MECHANICAL SAFETY REPORT',
                border: [0, 0, 0, 0],
                margin: [0, -40, 0, 0],
                fontSize: '15',
                alignment: 'center',
                bold: 'true'
              },
            ],


          ]
        },
        margin: [0, 0, 0, 10],
      },

      //-------Information Details -----

      {
        // 	layout: 'noBorders',
        table: {

          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [
              {
                text: 'SERVICE NAME\n',
                border: [1, 1, 0, 0],
                // 		bold:'true',
                style: 'commonFontSize',
                margin: 0,
                colSpan: 3,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: '',
                style: 'commonFontSize',
                margin: 0,
                border: [0, 1, 0, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: '',
                style: 'commonFontSize',
                margin: 0,
                border: [0, 1, 0, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'DATE OF INSPECTION',
                style: 'commonFontSize',
                margin: 0,
                border: [1, 1, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],
            [
              {
                text: data.serviceName,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, -4, 0, 0],
                border: [1, 0, 0, 1],
                colSpan: 3,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: '',
                style: 'commonFontSize',
                margin: 0,
                border: [0, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: '',
                style: 'commonFontSize',
                margin: 0,
                border: [0, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: timePipe.transform(data.inspectionDate, "MM/DD/YYYY"),
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, -4, 0, 0],
                border: [1, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],

            [
              {
                text: 'VEHICLE MAKE',
                // 		bold:'true',
                style: 'commonFontSize',
                margin: 0,
                border: [1, 1, 0, 0],

                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'MODEL',
                style: 'commonFontSize',
                margin: 0,
                border: [1, 1, 0, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'VEHICLE DECAL NUMBER',
                style: 'commonFontSize',
                margin: 0,
                border: [1, 1, 0, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'SERVICE VEHICLE NUMBER',
                style: 'commonFontSize',
                margin: 0,
                border: [1, 1, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],
            [
              {
                text: data.vehicleMake,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, -4, 0, 0],
                border: [1, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.vehicleModel,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, -4, 0, 0],
                border: [1, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.vehicleDecalNumber,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, -4, 0, 0],
                border: [1, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.vehicleServiceNumber,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, -4, 0, 0],
                border: [1, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],

            [
              {
                text: 'VEHICLE IDENTIFICATION NUMBER',
                // 		bold:'true',
                style: 'commonFontSize',
                margin: 0,
                border: [1, 1, 0, 0],
                // 		colSpan:2,

                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: '',
                style: 'commonFontSize',
                margin: 0,
                border: [0, 0, 0, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'CURRENT MILEAGE',
                style: 'commonFontSize',
                margin: 0,
                border: [1, 1, 0, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'DATE OF LAST INSPECTION',
                style: 'commonFontSize',
                margin: 0,
                border: [1, 1, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],
            [
              {
                text: data.vIdentificationNumber,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, -4, 0, 0],
                border: [1, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: '',
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, -4, 0, 0],
                border: [0, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.currentMileage,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, -4, 0, 0],
                border: [1, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: timePipe.transform(data.lastInspectionDate, "MM/DD/YYYY"),
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, -4, 0, 0],
                border: [1, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],

            [
              {
                text: data.serviceType === "Ambulance" ? "\uf00c\tAmbulance" : "Ambulance",
                // 		bold:'true',
                style: 'commonFontSize',
                margin: 0,
                border: [1, 0, 0, 1],

                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.serviceType === "MoICU" ? "\uf00c\tMoICU" : "MoICU",
                style: 'commonFontSize',
                margin: 0,
                border: [0, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.serviceType === "Non Transport Vehicle" ? "\uf00c\tNon-Transport Vehicle" : "Non-Transport Vehicle",
                style: 'commonFontSize',
                margin: 0,
                border: [0, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.serviceType === "Ambulette" ? "\uf00c\Ambulette" : "Ambulette",
                style: 'commonFontSize',
                margin: 0,
                border: [0, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],
          ]
        },
        margin: [0, -45, 0, 0],
        // 		layout: 'noBorders',
      },
      // -------Header table end --------------

      // -----Text table---

      {
        // 	layout: 'noBorders',
        table: {

          widths: ['100%'],
          body: [
            [
              {
                text: 'Please mark each item listed below as either passed or failed.',
                fontSize: '10',
                bold: 'true',
                margin: [0, 3, 0, 3],
                border: [0, 0, 0, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },



            ],

            [
              {
                text: 'All failed items must have a date indicating when the item was corrected and include supporting documentation.',
                fontSize: '10',
                bold: 'true',
                margin: [0, -5, 0, 0],
                border: [0, 0, 0, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },



            ],

          ]
        },
        margin: [0, 2, 0, 2],
        // 		layout: 'noBorders',
      },

      // -----Text table end ---


      // ------ Table data here DRIVER / PASSANGER COMPARTMENT-----
      {
        // 	layout: 'noBorders',
        table: {

          widths: ['60%', '10%', '10%', '20%'],
          body: [
            [
              {
                text: 'FRONT DRIVER / PASSENGER COMPARTMENT',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'PASSED',
                alignment: 'center',
                bold: 'true',

                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'FAILED',
                bold: 'true',
                alignment: 'center',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'DATE CORRECTED',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],

            [
              {
                text: 'Seats secure to floor and in safe condition',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.ssFloor === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.ssFloor === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.ssFloorDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Safety belts operational and free of visible damage',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.sbOperational === "true" ? "\uf00c" : "",
                alignment: 'center',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.sbOperational === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.sbOperationalDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 10,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Floor intact / free of holes',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.fintact === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.fintact === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.fintactDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: [0, 3, 0, 3],
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Doors / Door panels operational without breach',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.dpOperational === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.dpOperational === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.dpOperationalDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Compartment is clean / free of debris',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.cdClean === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.cdClean === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.cdCleanDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Instruments / gauges in proper working order',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.igWorking === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.igWorking === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.igWorkingDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Heat / AC operational',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.hacOperational === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.hacOperational === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 10,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.hacOperationalDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Window without breach, unobstructed, operational',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.wbOperational === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.wbOperational === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.wbOperationalDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: [0, 3, 0, 3],
                fontSize: 10,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Windshield wipers and washer operational',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.wwOperational === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.wwOperational === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.wwOperationalDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Mirrors, driver and passenger side, without breach',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.mdPassenger === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.mdPassenger === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.mdPassengerDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Power Steering operational',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.psOperational === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.psOperational === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.psOperationalDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Steering shaft secure - No excessive play',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.ssSecure === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.ssSecure === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.ssSecureDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Horn operational / audible',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.hOperational === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.hOperational === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.hOperationalDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Siren operational / audible',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.sirenOperational === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.sirenOperational === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.sirenOperationalDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Airbags',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.airBags === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.airBags === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.airBagsDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Emergency / parking brake operational',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.pbOperational === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.pbOperational === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.pbOperationalDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Audible backup alarm operational',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.driverPassengerCompartment.backupAlarmOperational === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.driverPassengerCompartment.backupAlarmOperational === "false" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.driverPassengerCompartment.backupAlarmOperationalDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],


            [
              {
                text: 'Comments',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 0],
                colSpan: 4,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: data.driverPassengerCompartment.comment,


                margin: 0,
                fontSize: 8,
                border: [1, 0, 1, 1],
                colSpan: 4,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                // 		bold:'true',
                margin: [0, 3, 0, 3],
                fontSize: 10,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                // 		bold:'true',
                margin: [0, 3, 0, 3],
                fontSize: 10,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: "",
                // 		bold:'true',
                margin: [0, 3, 0, 3],
                fontSize: 10,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],

              },
            ],




            // -------Tyre wheels end---


          ]
        },
        margin: [0, 0, 0, 60],

        // 		layout: 'noBorders',
      },


      // -------TIRES / WHEELS -----
      {
        // 	layout: 'noBorders',
        table: {

          widths: ['60%', '10%', '10%', '20%'],
          body: [
            [
              {
                text: 'TIRES / WHEELS',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'PASSED',
                bold: 'true',
                alignment: 'center',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'FAILED',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'DATE CORRECTED',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],

            [
              {
                text: 'Tires match and are correct size \t\t\t\t\t\t\t\t RF\tLF\tRR\tLR',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.msTires === "true" ? "\uf00c" : "",
                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.msTires === "false" ? "\uf00c" : "",

                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.msTiresDate, "MM/DD/YYYY"),

                // 		bold:'true',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Tire Pressure \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   RF\tLF\tRR\tLR',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.tPressure === "true" ? "\uf00c" : "",

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.tPressure === "false" ? "\uf00c" : "",

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.tPressureDate, "MM/DD/YYYY"),

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: 'Tire tread condition min 1/16th inch \t\t\t\t\t\t  RF\tLF\tRR\tLR',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.tireTread === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.tireTread === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.tireTreadDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Unusual tire wear tread / sidewall \t\t\t\t\t\t\t   RF\tLF\tRR\tLR',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.wearTread === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.wearTread === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.wearTreadDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Valve stems \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t RF\tLF\tRR\tLR',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.valveStems === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.valveStems === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.valveStemsDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: 'Rims / Wheels free of damage \t\t\t\t\t\t\t\t\t RF\tLF\tRR\tLR',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.wheelDamage === "true" ? "\uf00c" : "",

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.wheelDamage === "false" ? "\uf00c" : "",

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.wheelDamageDate, "MM/DD/YYYY"),

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Tires have full range of motion \t\t\t\t\t\t\t\t\t RF\tLF\tRR\tLR',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.tireMotion === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.tireMotion === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.tireMotionDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Rack-and-pinion, linkage and boots',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.rpLinkage === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.rpLinkage === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.rpLinkageDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Control arms, bushings, and ball joints',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.abJoints === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.abJoints === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.abJointsDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Sway bars, links, and bushings',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.slBushings === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.slBushings === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.slBushingsDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Springs',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.springs === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.springs === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.springsDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Shocks and struts',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.shockStruts === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.shockStruts === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.shockStrutsDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Power streeing pump',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.tireWheels.powerSteering === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.tireWheels.powerSteering === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.tireWheels.powerSteeringDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],



            // ------COMMENTS----
            [
              {
                text: 'Comments',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 0],
                colSpan: 4,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: data.tireWheels.comment,

                margin: 0,
                fontSize: 8,
                border: [1, 0, 1, 1],
                colSpan: 4,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],

              },
            ],

            //  	-----COMMENTS END---






            // -------Tyre wheels end---


          ]
        },
        margin: [0, -50, 0, 0],
        pageBreak: 'after'
        // 		layout: 'noBorders',
      },


      //  --------BREAKS----------
      {
        // 	layout: 'noBorders',
        table: {

          widths: ['60%', '10%', '10%', '20%'],
          body: [
            [
              {
                text: 'BRAKES',
                bold: 'true',
                margin: 0,

                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'PASSED',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'FAILED',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'DATE CORRECTED',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],

            [
              {
                text: 'Rotors and drums\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tRF\tLF\tRR\tLR',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.brakes.rotorDrums === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.brakes.rotorDrums === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.brakes.rotorDrumsDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Brake pads and shoes\t\t\t\t\t\t\t\t\t\t\t\t\t RF\tLF\tRR\tLR',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.brakes.breakPads === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.brakes.breakPads === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.brakes.breakPadsDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: 'Brake lines, hoses, and fittings\t\t\t\t\t\t\t\t\t  RF\tLF\tRR\tLR',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.brakes.breakLines === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.brakes.breakLines === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.brakes.breakLinesDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Master cylinder and booster',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.brakes.masterCylinder === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.brakes.masterCylinder === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.brakes.masterCylinderDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: 'ABS working properly',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.brakes.absOperational === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.brakes.absOperational === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.brakes.absOperationalDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],





            // ------COMMENTS----
            [
              {
                text: 'Comments',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 0],
                colSpan: 4,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: data.brakes.comment,

                margin: 0,
                fontSize: 8,
                border: [1, 0, 1, 1],
                colSpan: 4,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],

              },
            ],

            //  	-----COMMENTS END---






            // -------Tyre wheels end---


          ]
        },
        margin: [0, 15, 0, 50],
        // 		pageBreak: 'after'
        // 		layout: 'noBorders',
      },


      // -------BODY AND FRAMES----
      {
        // 	layout: 'noBorders',
        table: {

          widths: ['60%', '10%', '10%', '20%'],
          body: [
            [
              {
                text: 'BODY AND FRAME',
                bold: 'true',
                margin: 0,

                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'PASSED',
                bold: 'true',
                alignment: 'center',
                margin: 0,

                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'FAILED',
                alignment: 'center',
                bold: 'true',
                margin: 0,

                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'DATE CORRECTED',
                bold: 'true',
                margin: 0,
                alignment: 'center',

                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],

            [
              {
                text: 'Protruding metal on vehicle body',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.bodyFrame.metalProtruding === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.bodyFrame.metalProtruding === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.bodyFrame.metalProtrudingDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Bumpers',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.bodyFrame.bumpers === "true" ? "\uf00c" : "",
                //	margin:0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.bodyFrame.bumpers === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.bodyFrame.bumpersDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: 'Hood',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.bodyFrame.hood === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.bodyFrame.hood === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.bodyFrame.hoodDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Fenders',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.bodyFrame.fenders === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.bodyFrame.fenders === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.bodyFrame.fendersDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: 'Frame',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.bodyFrame.frame === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.bodyFrame.frame === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.bodyFrame.frameDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            // -COMMENTS----
            [
              {
                text: 'Comments',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 0],
                colSpan: 4,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: data.bodyFrame.comment,
                margin: 0,
                fontSize: 8,
                border: [1, 0, 1, 1],
                colSpan: 4,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],

              },
            ],

            //  	--COMMENTS END---






            // -------Tyre wheels end---


          ]
        },
        margin: [0, -45, 0, 0],
        // 		pageBreak: 'after'
        // 		layout: 'noBorders',
      },

      // -------Fuel System----
      {
        // 	layout: 'noBorders',
        table: {

          widths: ['60%', '10%', '10%', '20%'],
          body: [
            [
              {
                text: 'FUEL SYSTEM',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'PASSED',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'FAILED',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'DATE CORRECTED',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],

            [
              {
                text: 'Fuel pump',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.fuelSystem.fuelPump === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.fuelSystem.fuelPump === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.fuelSystem.fuelPumpDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Hoses & fitting',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.fuelSystem.hoseFitting === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.fuelSystem.hoseFitting === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.fuelSystem.hoseFittingDate, "MM/DD/YYYY"),
                // 		bold:'true',
                margin: [0, 3, 0, 3],
                fontSize: 10,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: 'Fuel lines',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.fuelSystem.fuelLines === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.fuelSystem.fuelLines === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.fuelSystem.fuelLinesDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Fuel tank',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.fuelSystem.fuelTank === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.fuelSystem.fuelTank === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.fuelSystem.fuelTankDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: 'Brackets and straps',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.fuelSystem.bracketStraps === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.fuelSystem.bracketStraps === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.fuelSystem.bracketStrapsDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            // -COMMENTS----
            [
              {
                text: 'Comments',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 0],
                colSpan: 4,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: data.fuelSystem.comment,
                margin: 0,
                fontSize: 8,
                border: [1, 0, 1, 1],
                colSpan: 4,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],

              },
            ],

            //  	--COMMENTS END---






            // -------Tyre wheels end---


          ]
        },
        margin: [0, 0, 0, 0],
        // 		pageBreak: 'after'
        // 		layout: 'noBorders',
      },


      // -----Exhaust system----


      {
        // 	layout: 'noBorders',
        table: {

          widths: ['60%', '10%', '10%', '20%'],
          body: [
            [
              {
                text: 'EXHAUST SYSTEM',
                uppercase: true,
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'PASSED',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'FAILED',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'DATE CORRECTED',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                fontSize: 9,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

            ],

            [
              {
                text: 'Manifold',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.exhaustSystem.maniFold === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.exhaustSystem.maniFold === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.exhaustSystem.maniFoldDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Pipes & fitting',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.exhaustSystem.pipesFitting === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.exhaustSystem.pipesFitting === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.exhaustSystem.pipesFittingDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: 'Muffler',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.exhaustSystem.muffler === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.exhaustSystem.muffler === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.exhaustSystem.mufflerDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            [
              {
                text: 'Bracket / hanger',
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.exhaustSystem.bracketHanger === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.exhaustSystem.bracketHanger === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.exhaustSystem.bracketHangerDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: 'Exhaust pipe / integrity',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.exhaustSystem.ExhaustPipe === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.exhaustSystem.ExhaustPipe === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.exhaustSystem.ExhaustPipeDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: 'Engine emissions check (if applicable) ',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.exhaustSystem.engineEmission === "true" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },

              {
                text: data.exhaustSystem.engineEmission === "false" ? "\uf00c" : "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                style:"fontAwesome"
              },
              {
                text: timePipe.transform(data.exhaustSystem.engineEmissionDate, "MM/DD/YYYY"),
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],

            // -COMMENTS----
            [
              {
                text: 'Comments',

                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 0],
                colSpan: 4,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
            ],
            [
              {
                text: data.exhaustSystem.comment,
                margin: 0,
                fontSize: 8,
                border: [1, 0, 1, 1],
                colSpan: 4,
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: "",
                margin: 0,
                fontSize: 8,
                border: [1, 1, 1, 1],
                alignment: 'center',
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],

              },
            ],

            //  	--COMMENTS END---






            // -------Tyre wheels end---


          ]
        },
        margin: [0, 0, 0, 0],
        // 		pageBreak: 'after'
        // 		layout: 'noBorders',
      },


      // -----Certfied mechanic varification------


      {
        // 	layout: 'noBorders',
        table: {

          widths: ['100%'],
          body: [
            [
              {
                text: 'CERTIFIED MECHANIC VERIFICATION',
                fontSize: '9',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                border: [0, 0, 0, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },



            ],



          ]
        },
        margin: [0, 0, 0, 0],
        // 		layout: 'noBorders',
      },

      {
        // 	layout: 'noBorders',
        table: {

          widths: ['100%'],
          body: [
            [
              {
                text: 'I attest I inspected this vehicle and completed this form.',
                fontSize: '9',
                // bold:'true',
                margin: 0,
                border: [1, 1, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },



            ],

            [
              {
                text: (data.mechanicVerification.isPassedInspection === "true" ? "\uf00c \t" : "") + 'This vehicle passsed inspection and is safe and roadworthy at the time of inspection.',
                fontSize: '8',
                // bold:'true',
                margin: 0,
                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },



            ],

            [
              {
                text: 'The vehicle has failed inspection',
                fontSize: '8',
                // bold:'true',
                margin: [12, 0, 0, 3],
                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },



            ],

            [
              {
                text: (data.mechanicVerification.isPassedInspection === "false" ? "\uf00c \t" : "") + 'I have made the service aware of all failed items identified during the inspection that require correction.',
                fontSize: '8',
                // bold:'true',
                margin: [0, -8, 0, 0],
                border: [1, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },



            ],



          ]
        },
        margin: [0, 2, 0, 0],
        // 		layout: 'noBorders',
      },

      {
        // 	layout: 'noBorders',
        table: {

          widths: ['40%', '40%', '20%'],
          body: [
            [
              {
                text: 'NAME',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'SIGNATURE',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'DATE',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },


            ],
            [
              {
                text: data.mechanicVerification.name,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              // {
              //   text: data.mechanicVerification.signature,
              //   bold: 'true',
              //   style: 'commonFontSize',
              //   margin: [0, 0, 0, 0],

              //   border: [1, 0, 1, 1],
              //   borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              // },

              (data.mechanicVerification.signature && data.mechanicVerification.signature.includes("http")  ? {
                image:await urlToBase64(data.mechanicVerification.signature),
                width:30,
                height:30,
                border: [0, 0, 0, 0],
                margin: [0, 0, 0, 0],
              }:  {
                text: "",
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],
                border: [1, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              }),

              {
                text: timePipe.transform(data.mechanicVerification.verificationDate, "MM/DD/YYYY"),
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },


            ],

            [
              {
                text: 'TITLE',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'CERTIFICATION / QUALIFICATIONS',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],
                colSpan: 2,
                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: '',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },


            ],
            [
              {
                text: data.mechanicVerification.title,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.mechanicVerification.certification,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [0, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: '',
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [0, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },


            ],

            [
              {
                text: 'EMPLOYER\'S NAME',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'PHONE NUMBER',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],
                colSpan: 2,
                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: '',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },


            ],
            [
              {
                text: data.mechanicVerification.employerName,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.mechanicVerification.phoneNumber,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: '',
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [0, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },


            ],


            //  	--COMMENTS END---






            // -------Tyre wheels end---


          ]
        },
        margin: [0, 0, 0, 0],
        // 		pageBreak: 'after'
        // 		layout: 'noBorders',
      },


      //  ----------Service Representative last section-----
      {
        // 	layout: 'noBorders',
        table: {

          widths: ['100%'],
          body: [
            [
              {
                text: 'SERVICE REPRESENTATIVE',
                fontSize: '9',
                alignment: 'center',
                bold: 'true',
                margin: 0,
                border: [0, 0, 0, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },



            ],



          ]
        },
        margin: [0, 0, 0, 0],
        // 		layout: 'noBorders',
      },

      {
        // 	layout: 'noBorders',
        table: {

          widths: ['100%'],
          body: [
            [
              {
                text: userData.stateCode === 'OH' ? 'I attest that this inspection was conducted in accordance with the requirements set forth in Section 4766 of the OHIO Administrative Code (O.A.C), and that all failed items identified during the inspection have been corrected prior to placing the vehicle back into service.':
                'I attest that this inspection was conducted in accordance with the requirements of State Administrative Code (O.A.C), and that all failed items identified during the inspection have been corrected prior to placing the vehicle back into service.',
                fontSize: '9',
                // bold:'true',
                margin: 0,
                border: [1, 1, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },



            ],




          ]
        },
        margin: [0, 2, 0, 0],
        // 		layout: 'noBorders',
      },

      {
        // 	layout: 'noBorders',
        table: {

          widths: ['50%', '50%'],
          body: [
            [
              {
                text: 'NAME',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 1, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: 'TITLE',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 1, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },



            ],
            [
              {
                text: data.representative.name,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },

              {
                text: data.representative.title,
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },




            ],

            [
              {
                text: 'SIGNATURE',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
              {
                text: 'DATE',
                style: 'commonFontSize',
                alignment: 'right',
                margin: [0, 0, 19, 0],

                border: [1, 0, 1, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },



            ],
            [
              // {
              //   text: data.representative.signature,
              //   bold: 'true',
              //   style: 'commonFontSize',
              //   margin: [0, 0, 0, 0],

              //   border: [1, 0, 1, 1],
              //   borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              // },

              (data.representative.signature && data.representative.signature.includes("http") ? {
                image:await urlToBase64(data.representative.signature),
                width:30,
                height:30,
                border: [1, 0, 0, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6'],
                margin: [0, 0, 0, 0],
              }:  {
                text:"",
                bold: 'true',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],
                border: [1, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              }),

              {
                text: timePipe.transform(data.representative.date, "MM/DD/YYYY"),
                bold: 'true',
                alignment: 'right',
                style: 'commonFontSize',
                margin: [0, 0, 0, 0],

                border: [0, 0, 1, 1],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },



            ],



          ]
        },
        margin: [0, 0, 0, 0],
        // 		pageBreak: 'after'
        // 		layout: 'noBorders',
      },

    ],

    styles: {
      commonFontSize: {
        fontSize: 8,
        font: 'Roboto'
      },
      fontAwesome: {
        fontSize: 8,
        font: 'FontAwesome'
      }
    },
    images: {
      headerLogo: 'data:image/png;base64,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',
    }
  }
}

